import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../../../constants';
import { closeModal } from '../../../../../store/modals';
import { IStateType } from '../../../../../store/models/root.interface';
import { requestObjects, updateObjects } from '../../../../../store/Objects';

import DeleteConfiguration, { DispatchPropsType, BaseSeeMorePropsType } from '../../organisms/receiveMessage/deleteConfiguration';

const mapStateToProps = (state: IStateType) => ({
    visible: state.modals.isOpen,
    id: state.modals.params,
    keyword: state.modals.params?.extraParams,
    number_type: state.modals.params?.extraParams?.number_type
})

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeModal()),
    onDelete: (reqData: any, cb: (res: any, success: boolean) => void) => dispatch(updateObjects(Instances.vmnConfigurationDelete, "DELETE", reqData, undefined, undefined, undefined, undefined, undefined, cb, '')),
    onLoad: () => dispatch(requestObjects(Instances.vmnConfigurationListing))
})

export default connect<BaseSeeMorePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(DeleteConfiguration));
